<div>
  @if (courseModules$ | async; as courseModules) {
    <section class="clp-card">
      <div class="clp-card-body">
        <div class="mb-3 flex items-center justify-between gap-2">
          <h3 class="text-base font-semibold text-slate-100">{{ 'courseModule.title' | translate }}</h3>
          <span class="module-count-badge">
            {{ courseModules.length }}
          </span>
        </div>

        @if (courseModules && courseModules.length > 0) {
          <div class="module-table-shell">
            <div class="overflow-x-auto">
              <table class="module-table">
                <thead class="module-table-head">
                  <tr>
                    <th class="module-th">{{ 'general.actions' | translate }}</th>
                    <th class="module-th">{{ 'courseModule.name' | translate }}</th>
                    <th class="module-th">{{ 'courseModule.order' | translate }}</th>
                    <th class="module-th">{{ 'lesson.title' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  @for (module of courseModules; track module.id ?? $index) {
                    <tr class="module-row">
                      <td class="module-actions-cell">
                        <div class="module-actions">
                        <button
                          class="module-action-btn module-action-btn-edit"
                          (click)="editCourseModule(module.id)"
                          [attr.aria-label]="'general.edit' | translate"
                          [title]="'general.edit' | translate">
                          <i class="fa-regular fa-pen-to-square text-xs"></i>
                        </button>
                        <button
                          class="module-action-btn module-action-btn-delete"
                          (click)="deleteCourseModule(module.id)"
                          [attr.aria-label]="'general.delete' | translate"
                          [title]="'general.delete' | translate">
                          <i class="fa-solid fa-trash-can text-xs"></i>
                        </button>
                        </div>
                      </td>
                      <td class="module-title-cell">{{ module.title }}</td>
                      <td class="module-order-cell">{{ module.order }}</td>
                      <td class="module-lessons-cell">
                        <span class="module-lessons-badge">
                          {{ module.lessons?.length ?? 0 }}
                        </span>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        } @else {
          <div class="module-empty">
            <i class="fa-solid fa-layer-group text-2xl text-slate-500"></i>
            <p class="mt-2 text-sm text-slate-300">{{ 'courseModule.noModules' | translate }}</p>
          </div>
        }
      </div>
    </section>
  }
</div>
